import './TimeShift.scss'
import { formatTime } from "../../../../Util/format_date";

import live_icon from '../../images/live.png'
import icon_small_screen from "../../images/full-screen_.png";
import icon_full_screen from "../../images/full-screen.png";

export default function TimeShift({
    btn_full_screen,
    fullScreen,
    currentTime,
    duration,
    show_time_shift,
    change_handle_range,
    valueProgress,
    showArchive,
    activeMedia,
    btn_play_pause,
    playPause,
    btn_forward,
    btn_back_forward
}) {

    return (
        <div id={'timeshift'}>

            <div className="container_player timeshift_main">
                <div className={"movie_player_middle_controls " + (!activeMedia.has_archive ? 'small' : '')}>

                    <div className="btns_mid_controls btn_back_forward live" onClick={btn_back_forward} onDoubleClick={e => e.stopPropagation()}>
                        <div className={'icon_control_player'}></div>
                    </div>
                    <div className="btns_mid_controls btn_play" onClick={btn_play_pause} onDoubleClick={e => e.stopPropagation()}>
                        <div
                            className={`${playPause ? 'icon_control_player_play' : 'icon_control_player_pause'} icon_control_player`}></div>
                    </div>
                    <div className="btns_mid_controls btn_forward live" onClick={btn_forward} onDoubleClick={e => e.stopPropagation()}>
                        <div className={'icon_control_player'}></div>
                    </div>

                </div>
                <div className="full_screen_btn" onClick={btn_full_screen} onDoubleClick={e => e.stopPropagation()}>
                    <img src={fullScreen ? icon_small_screen : icon_full_screen} alt="" />
                </div>
                <div className="progress_field">

                    <div className="duration_player" style={{ textAlign: 'left' }}>
                        {showArchive ? '' + formatTime(currentTime) : '-' + formatTime(duration - currentTime)}
                    </div>
                    <div className="progress_player">
                        <input
                            type="range"
                            value={valueProgress}
                            onChange={change_handle_range}
                            style={{ background: `linear-gradient(to right, #AFAFAF 0%, #AFAFAF ${valueProgress}%, #5E5E5E ${valueProgress}%, #5E5E5E 100%)` }}
                        />
                    </div>
                    {showArchive ?
                        <div className="duration_player">{formatTime(duration)}</div> :
                        <div className="icon_live">
                            <img src={live_icon} alt="" />
                        </div>
                    }

                </div>
                <div className="btn_turn_to_live" onClick={show_time_shift} onDoubleClick={e => e.stopPropagation()}>
                    <div></div>
                    <p>Turn to Live</p>
                </div>
            </div>
        </div>

    )
}